import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const animals = [
  { word: "قِطّ", pronunciation: "qiṭṭ", meaning: "Cat", emoji: "🐱" },
  { word: "كَلْب", pronunciation: "kalb", meaning: "Dog", emoji: "🐶" },
  { word: "حِصَان", pronunciation: "ḥiṣān", meaning: "Horse", emoji: "🐴" },
  { word: "بَقَرَة", pronunciation: "baqara", meaning: "Cow", emoji: "🐄" },
  { word: "أَسَد", pronunciation: "asad", meaning: "Lion", emoji: "🦁" },
  { word: "فِيل", pronunciation: "fīl", meaning: "Elephant", emoji: "🐘" },
  { word: "طَائِر", pronunciation: "ṭāʾir", meaning: "Bird", emoji: "🐦" },
  { word: "سَمَكَة", pronunciation: "samakah", meaning: "Fish", emoji: "🐟" },
  { word: "أَرْنَب", pronunciation: "arnab", meaning: "Rabbit", emoji: "🐰" },
  { word: "قِرْد", pronunciation: "qird", meaning: "Monkey", emoji: "🐒" },
];

function AnimalsLesson() {
  const [selectedAnimal, setSelectedAnimal] = useState(null);
  const [clickedAnimals, setClickedAnimals] = useState(new Set());

  const handleClick = (animal) => {
    setSelectedAnimal(animal);
    setClickedAnimals((prev) => new Set(prev).add(animal.word));
    window.responsiveVoice.speak(animal.word, "Arabic Male");
  };

  const progress = (clickedAnimals.size / animals.length) * 100;

  return (
    <div dir="rtl" className="p-4 sm:p-6 text-center font-arabic min-h-screen bg-gradient-to-br from-yellow-50 to-white">
      <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-yellow-800">🐾 أسماء الحيوانات بالعربية</h2>

      {/* Progress Bar */}
      <div className="w-full max-w-md mx-auto bg-gray-200 rounded-full h-4 mb-4 overflow-hidden shadow-inner">
        <motion.div
          className="bg-green-500 h-full"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5 }}
        />
      </div>
      <p className="text-sm text-gray-600 mb-6">تم تعلم {clickedAnimals.size} من {animals.length} حيوان</p>

      <AnimatePresence>
        {selectedAnimal && (
          <motion.div
            key="animal-info"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
            className="text-lg sm:text-xl text-green-700 mb-6"
          >
            <p>Pronunciation: <strong>{selectedAnimal.pronunciation}</strong></p>
            <p>Meaning: <strong>{selectedAnimal.meaning}</strong></p>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 justify-center mb-6">
        {animals.map((animal, index) => {
          const learned = clickedAnimals.has(animal.word);
          return (
            <button
              key={index}
              onClick={() => handleClick(animal)}
              className={`text-xl font-semibold p-4 rounded-2xl shadow-md transition duration-200 text-wrap whitespace-pre-wrap break-words ${
                learned ? "bg-green-100 text-green-700" : "bg-white text-yellow-800 hover:bg-yellow-100"
              }`}
            >
              <div className="text-3xl">{animal.emoji}</div>
              {animal.word}
            </button>
          );
        })}
      </div>

      {/* ResponsiveVoice Script */}
      <script src="https://code.responsivevoice.org/responsivevoice.js?key=1X64heoV"></script>
    </div>
  );
}

export default AnimalsLesson;
